export type SubNavItem = {
  label: string
  href: string
}

export type NavItem = {
  label: string
  href: string
  submenu?: SubNavItem[]
}

export const navItems: NavItem[] = [
  { label: 'Startpagina', href: '#accueil' },
  { label: 'Over ons', href: '#a-propos' },
  {
    label: 'Voeding',
    href: '#alimentation',
    submenu: [
      { label: 'Kruidenierswaren', href: '#alimentation' },
      { label: 'Verse producten', href: '#alimentation' },
      { label: 'Diepvriesproducten', href: '#alimentation' },
    ],
  },
  { label: 'Dranken', href: '#boisson' },
  { label: 'Huis & Decoratie', href: '#maison' },
  { label: 'Elektronica', href: '#electronique' },
]
